export default "__VITE_ASSET__00aa4c87__"